<template>
  <div class="dengke-machine-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('dengkeMachine.list.title') }}</span>
        <el-button type="text" icon="el-icon-refresh" @click="refresh()" />
      </div>

      <!-- 统计卡片 -->
      <el-row :gutter="16" class="stats-row">
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-label">{{ $t('dengkeMachine.stats.total') }}</div>
            <div class="stat-value">{{ stats.total }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-label">{{ $t('dengkeMachine.stats.unit') }}</div>
            <div class="stat-value">{{ stats.unit }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-label">{{ $t('dengkeMachine.stats.perimeter') }}</div>
            <div class="stat-value">{{ stats.perimeter }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-label">{{ $t('dengkeMachine.stats.online') }}</div>
            <div class="stat-value text-success">{{ stats.online }}</div>
          </div>
        </el-col>
      </el-row>

      <!-- 应用类型切换：全部 / 单元 / 围墙 -->
      <el-radio-group v-model="applyType" size="small" class="apply-type-group" @change="changeApplyType">
        <el-radio-button label="">{{ $t('dengkeMachine.tab.all') }}</el-radio-button>
        <el-radio-button label="单元">{{ $t('dengkeMachine.tab.unit') }}</el-radio-button>
        <el-radio-button label="围墙">{{ $t('dengkeMachine.tab.perimeter') }}</el-radio-button>
      </el-radio-group>

      <!-- 查询条件 -->
      <el-form :inline="true" :model="conditions" class="search-form">
        <el-form-item :label="$t('dengkeMachine.search.buildingNum')">
          <el-input v-model="conditions.buildingNum" clearable
            :placeholder="$t('dengkeMachine.search.buildingNum')" style="width:160px" />
        </el-form-item>
        <el-form-item :label="$t('dengkeMachine.search.unitNum')">
          <el-input v-model="conditions.unitNum" clearable
            :placeholder="$t('dengkeMachine.search.unitNum')" style="width:160px" />
        </el-form-item>
        <el-form-item :label="$t('dengkeMachine.search.machineAlias')">
          <el-input v-model="conditions.machineAlias" clearable
            :placeholder="$t('dengkeMachine.search.machineAlias')" style="width:180px" />
        </el-form-item>
        <el-form-item :label="$t('dengkeMachine.search.machineCode')">
          <el-input v-model="conditions.machineCode" clearable
            :placeholder="$t('dengkeMachine.search.machineCode')" style="width:180px" />
        </el-form-item>
        <el-form-item :label="$t('dengkeMachine.search.machineIp')">
          <el-input v-model="conditions.machineIp" clearable
            :placeholder="$t('dengkeMachine.search.machineIp')" style="width:160px" />
        </el-form-item>
        <el-form-item :label="$t('dengkeMachine.search.onlineStatus')">
          <el-select v-model="conditions.onlineStatus" clearable
            :placeholder="$t('dengkeMachine.search.onlineStatus')" style="width:140px">
            <el-option :label="$t('dengkeMachine.table.online')" value="在线" />
            <el-option :label="$t('dengkeMachine.table.offline')" value="离线" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">{{ $t('common.search') }}</el-button>
          <el-button @click="resetConditions()">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>

      <!-- 设备列表 -->
      <el-table :data="dengkeMachines" border style="width:100%" v-loading="loading">
        <el-table-column prop="machineAlias" :label="$t('dengkeMachine.table.machineAlias')" min-width="180"
          show-overflow-tooltip />
        <el-table-column prop="machineCode" :label="$t('dengkeMachine.table.machineCode')" align="center" width="120" />
        <el-table-column prop="productName" :label="$t('dengkeMachine.table.productName')" align="center" width="140"
          show-overflow-tooltip />
        <el-table-column prop="applyType" :label="$t('dengkeMachine.table.applyType')" align="center" width="100" />
        <el-table-column prop="locationDetail" :label="$t('dengkeMachine.table.location')" min-width="200"
          show-overflow-tooltip />
        <el-table-column prop="buildingNum" :label="$t('dengkeMachine.table.buildingNum')" align="center" width="90" />
        <el-table-column prop="unitNum" :label="$t('dengkeMachine.table.unitNum')" align="center" width="90" />
        <el-table-column prop="machineIp" :label="$t('dengkeMachine.table.machineIp')" align="center" width="140" />
        <el-table-column prop="onlineStatus" :label="$t('dengkeMachine.table.onlineStatus')" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.onlineStatus === '在线' ? 'success' : 'info'" size="mini">
              {{ scope.row.onlineStatus === '在线' ? $t('dengkeMachine.table.online') : $t('dengkeMachine.table.offline') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('dengkeMachine.table.operation')" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetail(scope.row)">{{ $t('dengkeMachine.detail.title') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pagination" :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size" :total="page.total" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>

    <!-- 设备详情 -->
    <el-dialog :title="$t('dengkeMachine.detail.title')" :visible.sync="detailVisible" width="700px"
      append-to-body>
      <el-form label-width="140px" size="small" v-if="currentDetail">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.machineId')">{{ currentDetail.machineId }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.machineAlias')">{{ currentDetail.machineAlias }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.machineCode')">{{ currentDetail.machineCode }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.did')">{{ currentDetail.did }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.communityId')">{{ currentDetail.communityId }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.subsystem')">{{ currentDetail.subsystem }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.productName')">{{ currentDetail.productName }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.productType')">{{ currentDetail.productType }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.applyType')">{{ currentDetail.applyType }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.direction')">{{ currentDetail.direction }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.locationDetail')">{{ currentDetail.locationDetail }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.machineIp')">{{ currentDetail.machineIp }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.factory')">{{ currentDetail.factory }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.onlineStatus')">{{ currentDetail.onlineStatus }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.serialNumber')">{{ currentDetail.serialNumber }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.macAddress')">{{ currentDetail.macAddress }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.hardwareVersion')">{{ currentDetail.hardwareVersion }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.mainVersion')">{{ currentDetail.mainVersion }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.faceVersion')">{{ currentDetail.faceVersion }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.fingerVersion')">{{ currentDetail.fingerVersion }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.buildingNum')">{{ currentDetail.buildingNum }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.unitNum')">{{ currentDetail.unitNum }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.icCardNum')">{{ currentDetail.icCardNum }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.faceNum')">{{ currentDetail.faceNum }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.fingerNum')">{{ currentDetail.fingerNum }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.bluetoothNum')">{{ currentDetail.bluetoothNum }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.qrcodeNum')">{{ currentDetail.qrcodeNum }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dengkeMachine.detail.createTime')">{{ currentDetail.createTime }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="detailVisible = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listDengkeMachines } from '@/api/machine/dengkeMachineApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'DengkeMachineList',
  data() {
    return {
      loading: false,
      communityId: '',
      applyType: '',
      dengkeMachines: [],
      detailVisible: false,
      currentDetail: null,
      stats: {
        total: 0,
        unit: 0,
        perimeter: 0,
        online: 0
      },
      conditions: {
        buildingNum: '',
        unitNum: '',
        machineAlias: '',
        machineCode: '',
        machineIp: '',
        onlineStatus: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.refresh()
  },
  methods: {
    /**
     * 加载设备列表，同时统计各类型数量
     */
    async refresh() {
      await this._listDengkeMachines(this.page.current, this.page.size)
      await this._loadStats()
    },
    async _listDengkeMachines(page, rows) {
      try {
        this.loading = true
        const params = {
          page: page,
          row: rows,
          communityId: this.communityId,
          applyType: this.applyType,
          buildingNum: this.conditions.buildingNum,
          unitNum: this.conditions.unitNum,
          machineAlias: this.conditions.machineAlias,
          machineCode: this.conditions.machineCode,
          machineIp: this.conditions.machineIp,
          onlineStatus: this.conditions.onlineStatus
        }
        const { data, total } = await listDengkeMachines(params)
        this.dengkeMachines = data
        this.page.total = total
      } catch (error) {
        console.error(this.$t('dengkeMachine.message.fetchError'), error)
        this.dengkeMachines = []
        this.page.total = 0
      } finally {
        this.loading = false
      }
    },
    /**
     * 统计数据：总数 / 单元 / 围墙 / 在线
     */
    async _loadStats() {
      try {
        const baseParams = {
          page: 1,
          row: 1000,
          communityId: this.communityId
        }
        const [allRes, unitRes, perimeterRes] = await Promise.all([
          listDengkeMachines(baseParams),
          listDengkeMachines({ ...baseParams, applyType: '单元' }),
          listDengkeMachines({ ...baseParams, applyType: '围墙' })
        ])
        this.stats.total = allRes.total
        this.stats.unit = unitRes.total
        this.stats.perimeter = perimeterRes.total
        this.stats.online = (allRes.data || []).filter(item => item.onlineStatus === '在线').length
      } catch (error) {
        console.error(this.$t('dengkeMachine.message.fetchError'), error)
      }
    },
    search() {
      this.page.current = 1
      this._listDengkeMachines(this.page.current, this.page.size)
    },
    changeApplyType() {
      this.page.current = 1
      this._listDengkeMachines(this.page.current, this.page.size)
    },
    resetConditions() {
      this.conditions = {
        buildingNum: '',
        unitNum: '',
        machineAlias: '',
        machineCode: '',
        machineIp: '',
        onlineStatus: ''
      }
      this.page.current = 1
      this._listDengkeMachines(this.page.current, this.page.size)
    },
    showDetail(row) {
      this.currentDetail = row
      this.detailVisible = true
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this._listDengkeMachines(this.page.current, this.page.size)
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listDengkeMachines(this.page.current, this.page.size)
    }
  }
}
</script>

<style lang="scss" scoped>
.dengke-machine-container {
  padding: 20px;

  .stats-row {
    margin-bottom: 15px;
  }

  .stat-card {
    border: 1px solid var(--ds-gray-200, #ebeef5);
    border-radius: 4px;
    padding: 14px 16px;
    background-color: #fff;

    .stat-label {
      font-size: 13px;
      color: var(--ds-gray-500, #909399);
      margin-bottom: 6px;
    }

    .stat-value {
      font-size: 24px;
      font-weight: 600;
      color: var(--ds-gray-900, #303133);
    }
  }

  .apply-type-group {
    margin-bottom: 15px;
  }

  .search-form {
    margin-bottom: 5px;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }

  .flex {
    display: flex;
  }

  .justify-between {
    justify-content: space-between;
    align-items: center;
  }
}
</style>
